import { render } from "./mMIRResult.vue?vue&type=template&id=191fbcaa&scoped=true"
import script from "./mMIRResult.vue?vue&type=script&lang=js"
export * from "./mMIRResult.vue?vue&type=script&lang=js"

import "./mMIRResult.vue?vue&type=style&index=0&id=191fbcaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191fbcaa"]])

export default __exports__